import { useTranslation } from 'react-i18next';
import type { SubBrandModule } from 'types/capi/modules';
import type {
  Image as ImageType,
  InternalLink as CapiInternalLink
} from 'types/capi/shared';

import Image, { smallImageOptions } from '~/components/Image';
import Tracked from '~/components/Tracked';

function CarouselItem({
  image,
  link
}: {
  image: ImageType;
  link: CapiInternalLink;
}) {
  return (
    <Tracked.InternalLink
      to={link.path}
      variant="none"
      pagePosition="Homepage Top Silhouettes"
      name="SILHOUETTE_CARD"
    >
      <div className="flex flex-col gap-4">
        <div className="flex size-28 items-center justify-center rounded bg-white px-1 py-7 md:size-[168px] md:py-12">
          <Image
            src={image.url}
            className="w-full"
            alt={image.alt}
            loading="lazy"
            {...smallImageOptions({ pad: true })}
          />
        </div>
        <div className="leading-6">{link.text}</div>
      </div>
    </Tracked.InternalLink>
  );
}

type Props = { subBrands: SubBrandModule['items'] };

function Carousel({ subBrands }: Props) {
  return (
    <div className="custom-scrollbar flex items-start gap-2 self-stretch overflow-x-scroll pb-4 md:gap-6">
      {subBrands.map((sb) => (
        <CarouselItem image={sb.image} link={sb.link} key={sb.link.text} />
      ))}
    </div>
  );
}

export default function SubBrands({ subBrands }: Props) {
  const { t } = useTranslation('home');

  return (
    <div className="w-full bg-concrete">
      <div className="flex flex-col items-center justify-center gap-6 px-0 py-10 md:mx-auto md:max-w-6xl md:py-10">
        <div className="flex flex-col justify-center gap-6 self-stretch py-0 pl-4">
          <h2 className="text-[32px] leading-10 md:text-[40px] md:leading-[48px]">
            {t('browseMoreTopSilhouettes')}
          </h2>
          <Carousel subBrands={subBrands} />
        </div>
      </div>
    </div>
  );
}
